
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Es ist es noch zu früh, um über Erfolg oder Misserfolg der staatlichen Covid-Strategien zu urteilen. Dennoch lässt sich festhalten, dass der Schweizer Lockdown offenbar eine Eindämmung des Coronavirus bewirkt hat, und dass die mittelfristigen Aussichten für die Wirtschaft sich hierzulande nicht wesentlich von Schweden unterscheiden – dem Land, das auf einen Lockdown verzichtete.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;